var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Pipe } from '@angular/core';
var StandardLevelPipe = /** @class */ (function () {
    function StandardLevelPipe() {
    }
    StandardLevelPipe.prototype.transform = function (level) {
        if (level === 0)
            return 'No Level';
        return "Level " + level;
    };
    StandardLevelPipe = __decorate([
        Pipe({ name: 'standardLevel' })
    ], StandardLevelPipe);
    return StandardLevelPipe;
}());
export { StandardLevelPipe };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhbmRhcmQtbGV2ZWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzdGFuZGFyZC1sZXZlbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxPQUFPLEVBQUUsSUFBSSxFQUFpQixNQUFNLGVBQWUsQ0FBQztBQUdwRDtJQUFBO0lBT0EsQ0FBQztJQU5VLHFDQUFTLEdBQWhCLFVBQWlCLEtBQWE7UUFDMUIsSUFBSSxLQUFLLEtBQUssQ0FBQztZQUNYLE9BQU8sVUFBVSxDQUFDO1FBRXRCLE9BQU8sV0FBUyxLQUFPLENBQUM7SUFDNUIsQ0FBQztJQU5RLGlCQUFpQjtRQUQ3QixJQUFJLENBQUMsRUFBRSxJQUFJLEVBQUUsZUFBZSxFQUFFLENBQUM7T0FDbkIsaUJBQWlCLENBTzdCO0lBQUQsd0JBQUM7Q0FBQSxBQVBELElBT0M7U0FQWSxpQkFBaUIifQ==